module.exports = __webpack_public_path__ + "img/hill-city.5ca62595.jpg";